import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  form: {
    margin: 0,
  },
  formElements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  input: {
    width: '100%',
  },
  button: {
    width: '100%',
    height: '4.4rem',
  },
  policyLabel: {
    fontSize: '1.4rem',
    '& a': {
      margin: '0 0.5rem',
    },
  },
  termsOfUseLabel: {
    fontSize: '1.4rem',
    '& a': {
      margin: '0 0 0 0.5rem',
    },
  },
  validButtonWrapper: {
    position: 'relative',
    padding: '5rem 0 1rem',
  },
  buttonWrapperWithError: {
    position: 'relative',
    padding: '1rem 0 1rem',
  },
  subtitle: {
    marginBottom: '4rem',
    '& span': {
      maxWidth: '75%',
      '@media(max-width:450px)': {
        maxWidth: '100%',
      },
    },
  },
  eeWelcomeText: {
    textAlign: 'center',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    padding: '1rem',
    borderRadius: '1rem',
    backgroundColor: colors.blue[200],
    marginBottom: '4rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
